import React, { useState, useEffect, useRef } from "react";
import { Portal } from "react-portal";
import { useCookies } from "react-cookie";
import {
  Root,
  Dialog,
  Content,
  Body,
  Border,
  Text,
  Logo,
  Label,
  Form,
  Select,
  Option,
  Submit,
  FieldSet,
  Legend,
} from "./AgeConfirm.style";
import FocusLock from "react-focus-lock";
import logoSrc from "../../assets/images/popcorn-sutton-logo-footer.png";
import modalBorder from "../../assets/images/modal-border.png";
import useLockBodyScroll from "../../hooks/useLockBodyScroll";

const AgeConfirm = () => {
  // useLockBodyScroll();
  const [cookies, setCookie] = useCookies(["ageConfirm"]);
  const [isShow, setIsShow] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [isInvalid, setIsInvalid] = useState(false);

  const dialogRef = useRef(null);

  useEffect(() => {
    if (cookies.ageConfirm !== "confirmed") setIsShow(true);
  }, [cookies.ageConfirm]);

  useEffect(() => {
    if (isShow && dialogRef.current) {
      dialogRef.current.focus();
    }
  }, [isShow]);

  const months = [
    { value: "January" },
    { value: "February" },
    { value: "March" },
    { value: "April" },
    { value: "May" },
    { value: "June" },
    { value: "July" },
    { value: "August" },
    { value: "September" },
    { value: "October" },
    { value: "November" },
    { value: "December" },
  ];

  const years = () => {
    const date = new Date();
    let options = [];
    for (let i = 1930; i <= date.getFullYear(); i++) {
      options.push(i);
    }
    return options
      .map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))
      .slice()
      .reverse();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFormValues = {
      ...formValues,
      [name]: value,
    };
    console.info({ newFormValues });
    setFormValues(newFormValues);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.info({ formValues });
    if (
      ["", null, undefined].includes(formValues?.year) ||
      ["", null, undefined].includes(formValues?.month) ||
      ["", null, undefined].includes(formValues?.day)
    ) {
      return setIsInvalid(true);
    }
    setIsInvalid(false);
    const age = Math.floor(
      (new Date() -
        new Date(
          `${formValues.year}-${formValues.month}-${formValues.day}`
        ).getTime()) /
        3.15576e10
    );
    if (age >= 21) {
      setCookie("ageConfirm", "confirmed", {
        maxAge: 60 * 60 * 24 * 365,
      });
      setTimeout(() => {
        setIsShow(false);
      }, 75);
    } else {
      // alert(age + " -- " + `${formValues.year}-${formValues.month}-${formValues.day}`)
      window.location.href = "https://www.responsibility.org/";
    }
  };

  return isShow ? (
    <Portal>
      <FocusLock>
        <Root
          tabIndex={-1}
          role="dialog"
          aria-modal="true"
          $isShow={isShow}
          $isHide={!isShow}
          aria-label="Age Confirmation Modal"
        >
          <Dialog ref={dialogRef} tabIndex={-1}>
            <Content>
              <Body>
                <Logo src={logoSrc} alt="Popcorn Sutton"></Logo>
                <Border src={modalBorder} alt="border"></Border>
                <h1 className="m-b-24">Are you over 21?</h1>
                <p className="text-center">
                  Can we some see some ID please?
                  <br />
                  It’s part of our commitment to responsible drinking.
                </p>
                <Form onSubmit={handleSubmit}>
                  {isInvalid && (
                    <p
                      id="birthdate-error"
                      role="status"
                      style={{
                        color: "#DB8F5E",
                        position: "absolute",
                        top: "-24px",
                      }}
                    >
                      Invalid birthdate.
                    </p>
                  )}
                  <div style={{ width: "100%" }}>
                    <FieldSet>
                      <Legend>Enter Your Birthdate</Legend>
                      <Select
                        name="month"
                        value={formValues.month}
                        onChange={handleChange}
                        aria-label="Month"
                        autocomplete="bday-month"
                        aria-describedby={
                          isInvalid ? "birthdate-error" : undefined
                        }
                      >
                        <Option value="">Month</Option>
                        {months.map((month, idx) => (
                          <Option
                            key={month.value}
                            value={`${idx + 1}`.padStart(2, "0")}
                          >
                            {month.value}
                          </Option>
                        ))}
                      </Select>
                      <Select
                        name="day"
                        value={formValues.day}
                        onChange={handleChange}
                        aria-label="Day"
                        autocomplete="bday-day"
                      >
                        <Option value="">Day</Option>
                        {Array.from({ length: 31 }, (_, i) => (
                          <Option
                            key={i + 1}
                            value={`${i + 1}`.padStart(2, "0")}
                          >
                            {i + 1}
                          </Option>
                        ))}
                      </Select>
                      <Select
                        name="year"
                        value={formValues.year}
                        onChange={handleChange}
                        aria-label="Year"
                        autocomplete="bday-year"
                      >
                        <Option value="">Year</Option>
                        {years()}
                      </Select>
                    </FieldSet>
                  </div>

                  <Submit type="submit">Come In</Submit>
                </Form>
              </Body>
            </Content>
          </Dialog>
        </Root>
      </FocusLock>
    </Portal>
  ) : null;
};

export default AgeConfirm;
